function setAnnouncementHeight() {
  var bar = document.querySelector('.announcement-bar');
  if (!bar) return;
  var height = bar.getBoundingClientRect().height;
  document.documentElement.style.setProperty('--announcement-height', height + 'px');
}

setAnnouncementHeight();
window.addEventListener('resize', setAnnouncementHeight);

document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
  var slides = bar.querySelectorAll('[data-ab-slide]');
  if (slides.length < 2) return;

  var prevBtn = bar.querySelector('[data-ab-prev]');
  var nextBtn = bar.querySelector('[data-ab-next]');
  var current = 0;
  var autoplay = bar.dataset.autoplay === 'true';
  var interval = parseInt(bar.dataset.interval, 10) || 5000;
  var timer = null;

  function show(index) {
    slides[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
  }

  function next() {
    show(current + 1);
  }

  function prev() {
    show(current - 1);
  }

  function startAutoplay() {
    if (!autoplay) return;
    stopAutoplay();
    timer = setInterval(next, interval);
  }

  function stopAutoplay() {
    if (timer) clearInterval(timer);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      next();
      startAutoplay();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      prev();
      startAutoplay();
    });
  }

  bar.addEventListener('mouseenter', stopAutoplay);
  bar.addEventListener('mouseleave', startAutoplay);

  startAutoplay();
});
document.addEventListener('DOMContentLoaded', () => {
  const announcementBar = document.querySelector('.announcement-bar');

  if (!announcementBar) return;

  const updateAnnouncementBar = () => {
    if (window.scrollY > 20) {
      document.body.classList.add('announcement-hidden');
    } else {
      document.body.classList.remove('announcement-hidden');
    }
  };

  updateAnnouncementBar();

  window.addEventListener('scroll', updateAnnouncementBar, {
    passive: true
  });
});